import { render, staticRenderFns } from "./MBWhatsApp.vue?vue&type=template&id=fe23832a&scoped=true"
import script from "./MBWhatsApp.vue?vue&type=script&lang=js"
export * from "./MBWhatsApp.vue?vue&type=script&lang=js"
import style0 from "./MBWhatsApp.vue?vue&type=style&index=0&id=fe23832a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe23832a",
  null
  
)

export default component.exports